/**
 * 解析navigator.userAgent以获取设备型号
 * @param {string} userAgent 用户代理字符串
 * @returns {string} 设备型号
 */
function parseDeviceModel(userAgent: string): string {
  const userAgentLower = userAgent.toLowerCase();

  // 检查是否为iPhone
  if (/iphone/i.test(userAgentLower)) {
    return 'iPhone';
  }

  // 检查是否为iPad
  if (/ipad/i.test(userAgentLower)) {
    return 'iPad';
  }

  // 检查是否为iPod
  if (/ipod/i.test(userAgentLower)) {
    return 'iPod';
  }

  // 检查是否为Android设备
  if (/android/i.test(userAgentLower)) {
    // Android设备可能包含更具体的型号信息
    const androidModelMatch = userAgentLower.match(/(?:android[\/ ])([a-z0-9]+[-][a-z0-9]+)/i);
    if (androidModelMatch) {
      return androidModelMatch[1];
    }
    return 'Android';
  }

  // 检查是否为其他设备
  const commonDevices = [
    { model: /samsung/i, name: 'Samsung' },
    { model: /nexus/i, name: 'Nexus' },
    { model: /huawei/i, name: 'Huawei' },
    { model: /xiaomi/i, name: 'Xiaomi' },
    { model: /oppo/i, name: 'OPPO' },
    { model: /vivo/i, name: 'Vivo' },
    { model: /oneplus/i, name: 'OnePlus' },
    { model: /zte/i, name: 'ZTE' },
    { model: /motorola/i, name: 'Motorola' },
    { model: /lenovo/i, name: 'Lenovo' },
    { model: /asus/i, name: 'ASUS' },
    { model: /lg/i, name: 'LG' },
    { model: /sony/i, name: 'Sony' },
    { model: /nokia/i, name: 'Nokia' },
    { model: /htc/i, name: 'HTC' },
    { model: /blackberry/i, name: 'BlackBerry' },
    { model: /alcatel/i, name: 'Alcatel' },
    { model: /google/i, name: 'Google' },
    { model: /meizu/i, name: 'Meizu' },
    { model: /realme/i, name: 'Realme' },
    { model: /redmi/i, name: 'Redmi' },
    { model: /infinix/i, name: 'Infinix' },
    { model: /tecno/i, name: 'Tecno' },
    { model: /itel/i, name: 'Itel' },
    { model: /honor/i, name: 'Honor' }
  ];

  for (const device of commonDevices) {
    if (device.model.test(userAgentLower)) {
      // 尝试获取更具体的型号信息
      const modelMatch = userAgentLower.match(new RegExp(device.name + '[\\s-]([a-zA-Z0-9]+)'));
      if (modelMatch) {
        return modelMatch[1];
      }
      return device.name;
    }
  }

  // 如果无法识别设备，则返回空字符串
  return '';
}

export default parseDeviceModel;